/**
 * Normalize FastAPI `detail` (string, Pydantic validation list, or { msg }) for UI/toasts.
 */
export function formatApiErrorDetail(detail, fallback = 'Κάτι πήγε στραβά.') {
    if (detail == null || detail === '') return fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        const parts = detail
            .map((item) => {
                if (item == null) return null;
                if (typeof item === 'string') return item;
                if (typeof item === 'object' && typeof item.msg === 'string') return item.msg;
                return null;
            })
            .filter(Boolean);
        if (parts.length) return parts.join(' ');
        return fallback;
    }
    if (typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
    return fallback;
}
